import { render, staticRenderFns } from "./Longform.vue?vue&type=template&id=033b197f&scoped=true&"
import script from "./Longform.vue?vue&type=script&lang=js&"
export * from "./Longform.vue?vue&type=script&lang=js&"
import style0 from "./Longform.vue?vue&type=style&index=0&id=033b197f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033b197f",
  null
  
)

export default component.exports